export function getPricingURL(instanceId) {
  return 'https://grouper.io/get-license/' + instanceId + '/'
}
